import { render, staticRenderFns } from "./PH2L.vue?vue&type=template&id=5a0be55c&scoped=true"
import script from "./PH2L.vue?vue&type=script&lang=js"
export * from "./PH2L.vue?vue&type=script&lang=js"
import style0 from "./PH2L.vue?vue&type=style&index=0&id=5a0be55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0be55c",
  null
  
)

export default component.exports